import React from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { QueryResponse as Risk } from 'api/queries/getRisk.query';

import { AssigneeAvatarWithInlineSelect } from 'components/common/AssigneeAvatarWithInlineSelect/AssigneeAvatarWithInlineSelect';

import { CustomizedFormErrorMessage } from 'components/common';
import classes from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/Details/Details.module.scss';

export const Assignee = () => {
    const {
        setValue,
        control,
        formState: { errors },
    } = useFormContext<Risk>();

    const handleAssigneeSelect = (value) => {
        setValue('assigneeValue', value, { shouldDirty: true });
    };

    return (
        <div className={classes.selectWrapper}>
            <div className={classes.title}>Assignee:</div>
            <div className={classes.content}>
                <div className={classes.inlineSelectWrapper}>
                    <Controller
                        render={({ field }) => (
                            <AssigneeAvatarWithInlineSelect
                                {...field}
                                assigneeValue={field.value}
                                onSelection={handleAssigneeSelect}
                            />
                        )}
                        name={`assigneeValue`}
                        control={control}
                        rules={{
                            required: 'Assignee is Required',
                        }}
                    />
                    {errors.assigneeValue && <CustomizedFormErrorMessage text={errors.assigneeValue.message} />}
                </div>
            </div>
        </div>
    );
};
